export enum ReportMainMenuOption {
  Settings = 'settings',
  Content = 'content',
  View = 'view',
  History = 'history',
}

export enum ReportSettingsMenuOption {
  Info = 'settings',
  Sections = 'settings/sections',
  DataSources = 'settings/sources',
  Preferences = 'settings/preferences',
  Subscribers = 'settings/subscribers',
  Send = 'settings/send',
}

export enum ReportContentMenuOption {
  Content = 'content',
  Sort = 'content/sort',
  Summary = 'content/summary',
}

export enum ReportViewMenuOption {
  View = 'view',
}

export enum ReportHistoryMenuOption {
  History = 'history',
}
